<div class="unauthorized">
  <app-svg-icon src="./assets/icons/unauthorized.svg"></app-svg-icon>
</div>
